export const defaultChatButtonSubTitleStyles = {
  alignItems: "center",
  color: "#666",
  cursor: "pointer",
  display: "block",
  fontFamily: "'Segoe UI',Arial,sans-serif",
  fontSize: "12px",
  fontWeight: "200",
  margin: "0px 14px 0px 14px",
  overflow: "hidden",
  padding: "0px",
  textOverflow: "ellipsis !important",
  whiteSpace: "nowrap",
  minWidth: "90px",
  maxWidth: "105px"
};